import { connect } from 'react-redux';
import { setEditorType as setEditorTypeAction } from '@Pages/RetroSynthesis/DrawStructure/actions';
import { showSupplierPreferencesChangedToastMessage as showSupplierPreferencesChangedToastMessageAction } from './actions';
import Preferences from './Preferences';

const mapDispatchToProps = {
  setEditorType: setEditorTypeAction,
  showSupplierPreferencesChangedToastMessage: showSupplierPreferencesChangedToastMessageAction,
};

export default connect(null, mapDispatchToProps)(Preferences);
